import { Tooltip } from 'antd';
import React, { memo } from 'react';
import { AdditionalTariffSpreadsheet } from 'libs/htsHelpers';
import {
  StyledContainer,
  StyledDiv,
  StyledHeader,
  StyledInfoCircleOutlined,
  StyledTable,
} from './styles';

interface UpsertAdditionalTariffsPreview {
  additionalNumber: string;
  count: number;
}

interface UpsertAdditionalReviewProps {
  dataSource: UpsertAdditionalTariffsPreview[];
}

export interface ReviewProps {
  invoiceSpreadsheets?: AdditionalTariffSpreadsheet[];
  previewData?: UpsertAdditionalTariffsPreview[];
}

const reviewMessage =
  'The numbers below indicate how many HTS codes will be attached to each addtional tariff.';

const reviewColumns = [
  {
    title: 'Additional Tariff',
    dataIndex: 'additionalNumber',
  },
  {
    title: 'Number of HTS Codes',
    dataIndex: 'count',
  },
];

/**
 * ImportAdditionalTariffReview
 *
 * A sub-component of the ImportAdditionalTariffModal that contains the summary
 * of the ivoices to be imported.
 */

export const ImportAdditionalTariffReview: React.FC<
  UpsertAdditionalReviewProps
> = ({ dataSource }) => {
  return (
    <StyledContainer>
      <StyledDiv>
        <StyledHeader>
          Additional Tariffs and count of HTS codes impacted
          <Tooltip placement="bottom" title={reviewMessage}>
            <StyledInfoCircleOutlined />
          </Tooltip>
        </StyledHeader>
        <StyledTable
          columns={reviewColumns}
          dataSource={dataSource}
          pagination={false}
        />
      </StyledDiv>
    </StyledContainer>
  );
};

export default memo(ImportAdditionalTariffReview);
